// extracted by mini-css-extract-plugin
export var addButton = "_dp-4";
export var contentBlockImage = "_dp-i";
export var contentBlockWidgetPreview = "_dp-g";
export var fulfillmentCutoffWidgetPreview = "_dp-9";
export var imageBackdrop = "_dp-6";
export var imageIcon = "_dp-8";
export var lowProfileImageContainer = "_dp-b";
export var lowProfileImageIcon = "_dp-f";
export var lowProfileImageIconContainer = "_dp-e";
export var lowProfileImagePlaceholder = "_dp-d";
export var lowProfileProductImage = "_dp-c";
export var lowProfileProductUpsellWidgetPreview = "_dp-a";
export var productCard = "_dp-5";
export var productImage = "_dp-7";
export var productReviewsWidgetPreview = "_dp-h";
export var progressBar = "_dp-1";
export var progressBarFill = "_dp-2";
export var progressBarTrack = "_dp-3";
export var shippingOptionWidgetPreview = "_dp-j";
export var shippingUpsellProgressBar = "_dp-k";
export var thresholdUpsellWidgetPreview = "_dp-0";